import { render } from "./NavTab.vue?vue&type=template&id=75befb5c"
import script from "./NavTab.vue?vue&type=script&lang=js"
export * from "./NavTab.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/tab/NavTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "75befb5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('75befb5c', __exports__)) {
    console.log('reload')
    api.reload('75befb5c', __exports__)
  }
  
  module.hot.accept("./NavTab.vue?vue&type=template&id=75befb5c", () => {
    console.log('re-render')
    api.rerender('75befb5c', render)
  })

}


export default __exports__